// extracted by mini-css-extract-plugin
export default {"pageHeading":"_2546ee8c","pageTitle":"_1a78fc44"};